/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestCreateApiKey } from '../model/models';
import { ApiRequestRevokeApiKey } from '../model/models';
import { ApiResponseApiKey } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ApiKeyServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestCreateApiKey 
     */
    apiKeyControllerCreate0(apiRequestCreateApiKey: ApiRequestCreateApiKey, extraHttpRequestParams?: any): Observable<ApiResponseApiKey>;

    /**
     * 
     * 
     * @param apiRequestCreateApiKey 
     */
    apiKeyControllerCreate1(apiRequestCreateApiKey: ApiRequestCreateApiKey, extraHttpRequestParams?: any): Observable<ApiResponseApiKey>;

    /**
     * 
     * 
     * @param apiKey 
     */
    apiKeyControllerDecode0(apiKey: string, extraHttpRequestParams?: any): Observable<ApiResponseApiKey>;

    /**
     * 
     * 
     * @param apiKey 
     */
    apiKeyControllerDecode1(apiKey: string, extraHttpRequestParams?: any): Observable<ApiResponseApiKey>;

    /**
     * 
     * 
     * @param employerId 
     */
    apiKeyControllerFindActiveApiKey0(employerId: string, extraHttpRequestParams?: any): Observable<ApiResponseApiKey>;

    /**
     * 
     * 
     * @param employerId 
     */
    apiKeyControllerFindActiveApiKey1(employerId: string, extraHttpRequestParams?: any): Observable<ApiResponseApiKey>;

    /**
     * 
     * 
     * @param apiRequestRevokeApiKey 
     */
    apiKeyControllerRevokeApiKey0(apiRequestRevokeApiKey: ApiRequestRevokeApiKey, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param apiRequestRevokeApiKey 
     */
    apiKeyControllerRevokeApiKey1(apiRequestRevokeApiKey: ApiRequestRevokeApiKey, extraHttpRequestParams?: any): Observable<boolean>;

}
